import page from '../api/page'
import user from '../api/user'
import article from '../api/article'

const state = () => ({
  // currentGroupID:137,
  activeGroupID:0,
  groupInfo:{},
  groupTopBar:{},
  memberList: {
    lastID:0,
    nomore:true,
    data:{member:[]}
  },
  // 将各个角色合法成员数据打包成一个数组
  memberLists:[],
  groupViewArticle:{
    lastID:0,
    nomore:true,
    data:[]
  },
  groupList:[],
  groupOtherList:[],
  groupJoinList:[],
  user:{},
  article_list:{
    lastID:0,
    nomore:true,
    data:[]
  },
  // 正文页
  article_view:{},
  article_view_comment:{
    lastID:0,
    nomore:true,
    data:[]
  },
  recommand_group:{
    lastID:0,
    nomore:true,
    data:[]
  },
  new_group:{
    lastID:0,
    nomore:true,
    data:[]
  },
  group_join_article_list:{
    lastID:0,
    nomore:true,
    data:[]
  },
  // search in group
  search_in_group_result:[]
})
// getters
const getters = {
  //是否在我的群组里
  isMygroup(state){
    var status = false
    state.groupList.map(x=>{
      if(x.id === state.activeGroupID) status = true
    })
    state.groupJoinList.map(x=>{
      if(x.groupinfoID === state.activeGroupID) status = true
    })
    return status
  },
  initGroup(state){
    state.groupList=[];
    state.groupOtherList=[];
    state.groupJoinList=[];
  }
}

// actions
const actions = {
  async setActiveGroupID({commit},groupinfoID){
    commit('setActiveGroupID',groupinfoID)
  },
  async getGroupInfo({commit},groupinfoID){
    const res = await page.group_view(groupinfoID);
    commit('setGroupInfo',res.data);
    return res
  },
  async getGroupTopBar({commit,dispatch},groupinfoID){
    const res = await page.group_view_bar(groupinfoID);
    dispatch('GetGroupTopic',groupinfoID);
    commit('setGroupTopBar',res.data)
  },
  async getMemberList({commit},params){
    const res = await page.group_view_member(params.groupID,params.lastID);
    if(params.lastID===0){
      commit('initMemberList',res.data)
    }else{
      commit('setMemberList',res.data)
    }
  },
  async getGroupViewArticle({commit},params){
    if(params.lastID===0){
      commit('initPagination','groupViewArticle')
    }
    const res = await page.group_view_article(params.groupID,params.lastID);
    commit('setPagination',{who:'groupViewArticle',res:res,pageSize:20,label:'postID'})
  },
  async searchInGroup({commit},params){
    const res = await page.article_search_in_group(params);
    commit('setSearchInGroupResault', res);
  },
  async updateGroupInfo({dispatch},params){
    const res = await user.group_update(params);
    dispatch('getGroupInfo',params.groupinfoID);
    dispatch('getGroupTopBar',params.groupinfoID);
    dispatch('GetGroupList');
    return res;
  },
  async getMyGroups({commit}){
    const res = await user.group_list();
    commit('setMyGroups',res.data)
  },
  async joniGroup({dispatch},groupID){
    const res = await user.member_apply(groupID);
    dispatch('getMemberList',{groupID: groupID, lastID: 0});
    return res;
  },
  async removeGroup({commit},groupID){
    const res = await user.group_remove(groupID);
    commit('setActiveGroupID',0)
    return res;
  },
  async removeMember({dispatch},params){
    const res = await user.member_remove(params);
    return res
  },
  async GroupInvite({dispatch},params){
    const res = await user.member_invite(params);
    return res
  },
  async TopicAdd({commit,dispatch},params){
    const res = await user.topic_add(params);
    dispatch('GetGroupList');
    return res
  },
  async TopicRemove({commit},params){
    const res = await user.topic_remove(params);
    return res
  },
  async GetGroupList({commit,dispatch}){
    const res = await user.group_list();
    commit('setGroupList',res)
  },
  async GetGroupOtherList({commit}){
    const res = await page.group_list();
    commit('setGroupOtherList',res)
  },
  async GetGroupJoinList({commit}){
    const res = await user.group_join_list();
    commit('setGroupJoinList',res)
  },
  async GetGroupTopic({commit},groupID){
    const res = await page.group_view_topic(groupID);
    if(res.data){
      res.data = res.data.filter(x=>
        x.tag_tagID.visible === 1
      )
    }
    commit('setGroupTopic',res)
    return res
  },
  // get article list
  async GetArticalList({commit},parmas){
    const res = await page.article_list(parmas);
    commit('setArticalList',res)
  },
  async GetArticalView({commit},postID){
    const res = await page.article_view(postID);
    commit('setArticalView',res);
    return res
  },
  async GetArticalViewComment({commit},params){
    if(params.lastID===0 ){
      commit('initPagination','article_view_comment')
    }
    const res = await page.article_view_comment(params);
    if(res.data){
      commit('setPagination',{who:'article_view_comment',res:res,pageSize:20,label:'create_date'})
    }
  },
  async RewriteComment({commit},postID){
    const res = await page.article_view(postID);
    commit('rewriteComment',res);
  },
  async ReplyAdd({commit},params){
    const res = await article.reply_add(params);
    const comment = await page.article_view(res.data);
    commit('repleaceNewComment',[comment,params.article_data])
    
    return res
  },
  async EditReply({commit},params){
    const res = await article.reply_update(params);
    return res
  },
  async ReplyDelete({commit},postID){
    const res = await article.reply_delete(postID);
    if(res.status){
      commit('setDeleteComment',postID);
    }
    return res
  },
  async getRecommandGroup({commit}){
    const res = await page.recommand_group();
    commit('setRecommandGroup',res)
    return res;
  },
  async getNewGroup({commit}){
    const res = await page.new_group();
    commit('setNewGroup',res)
    return res;
  },
  async getGroupJoinArticleList({commit},lastID){
    const res = await user.group_join_article_list(lastID);
    commit('setGroupJoinArticleList',res)
  },
  async setArticalSticky({commit},params){
    const res = await article.article_sticky(params);
    return res
  },
  async setArticalPublish({commit},params){
    const res = await article.article_publish(params);
    return res
  },
  async changTopic({dispatch},params){
    const res = await article.article_shift_tag(params);
    return res
  }
}

// mutations
const mutations = {
  resetState (state) {
    Object.assign(state, state)
  },

  setActiveGroupID(state,res){
    state.activeGroupID = Number(res)
  },
  setGroupInfo(state,res){
    state.groupInfo = res;
    state.search_in_group_result = [];
  },
  setGroupTopBar(state,res){
    state.groupTopBar = res;
  },
  initMemberList(state,res){
    state.memberList.data = res;
    if(res.member.length===40){
      state.memberList.nomore = false;
      state.memberList.lastID = res.member[39].id;
    }else{
      state.memberList.nomore = true
    }
    state.memberLists = res.host.concat(res.admin,res.member)
  },
  setMemberList(state,res){
    state.memberList.data.host = res.host;
    state.memberList.data.admin = res.admin;
    state.memberList.data.verify = res.verify;
    if(res.member.length===40){
      state.memberList.nomore = false;
      state.memberList.lastID = res.member[39].id;
      state.memberList.data.member = state.memberList.data.member.concat(res.member)
    }else{
      if(!state.memberList.nomore){
        state.memberList.data.member = state.memberList.data.member.concat(res.member)
      }
      state.memberList.nomore = true
    }
    state.memberLists = res.host.concat(res.admin,res.member)
  },
  initGroupViewArticle(state){
    state.groupViewArticle.nomore = true;
    state.groupViewArticle.lastID = 0;
    state.groupViewArticle.data =[]
  },
  setGroupViewArticle(state,res){
    if(res.length===20){
      state.groupViewArticle.nomore = false;
      state.groupViewArticle.lastID = res[19].id;
      state.groupViewArticle.data = state.groupViewArticle.data.concat(res);
    }else{

      if(!state.groupViewArticle.nomore){
        state.groupViewArticle.data = state.groupViewArticle.data.concat(res);
      }
      state.groupViewArticle.nomore = true;
    }
  },
  setMyGroups(state,res){
    if(res.status){
      state.user.myGroup = res
    }  
  },
  setGroupList(state,res){
    if(res.status){
      state.groupList = res.data
    }
  },
  setGroupJoinList(state,res){
    if(res.status){
      state.groupJoinList = res.data
    }
  },
  setGroupOtherList(state,res){
    state.groupOtherList = res.data
  },
  setGroupTopic(state,res){ 
    if(res.data.length>0){
      const idx = state.groupList.findIndex(e=>e.id === res.data[0].groupinfoID);
      const index = state.groupJoinList.findIndex(e=>e.id === res.data[0].groupinfoID);
      if(idx>=0)state.groupList[idx].tags = res.data;
      if(index>=0)state.groupJoinList[index].tags = res.data;
      state.groupTopBar.tags = res.data;
    }
  },
  setArticalList(state,res){
    state.article_list.data = res.data
  },
  setArticalView(state,res){
    state.article_view = res
  },
  setArticalViewComment(state,res){
    if(res.data<20){
      state.article_view_comment.nomore = true;
      
    }else{
      state.article_view_comment.nomore = false;
    }
    
      state.article_view_comment.data = state.article_view_comment.data.concat(res.data);
  },
  rewriteComment(state,res){
    state.article_view_comment.data.forEach(x=>{
      if(x.postID===res.data.postID){
        x.postInfo_postID.msgbody=res.data.postInfo_postID.msgbody;
      }
      if(x.reply){
        x.reply.forEach(y=>{
          if(y.postID===res.data.postID){
            y.postInfo_postID.msgbody=res.data.postInfo_postID.msgbody;
          }
        })
      }
    })
  },
  setDeleteComment(state,postID){
    let d = state.article_view_comment.data;
    let idx = 0;
    idx = d.findIndex(x=>x.postID === postID)
    if(idx!=-1){
      d.splice(idx,1)
    }else{
      d.forEach(x=>{
        if(x.reply){
          idx = x.reply.findIndex(y=>y.postID === postID)
        }
        if(idx!=-1){
          x.reply.splice(idx,1)
        }
      })
    }
  },
  setRecommandGroup(state,res){
    state.recommand_group.data = res.data
  },
  setNewGroup(state,res){
    state.new_group.data = res.data
  },
  setGroupJoinArticleList(state,res){
    state.group_join_article_list.data = res.data
  },
  repleaceNewComment(state,res){
    let d = state.article_view_comment.data;
    let c = res[0].data;
    let parentID = res[1].postID;
    let inserted = false;
    if(!c.reply){
      c['reply']=[];
    }
    d.forEach((x)=>{
      if(x.postID === parentID){// 1 级回复
        x.reply.push(c)
        inserted = true;
      }
      x.reply.forEach(y=>{ // 2 级回复
        if(y.postID === parentID){
          x.reply.push(c)
          inserted = true;
        }
      })
    })
    if(!inserted){
      d.unshift(c)
    }
  },
  
  initPagination(state,who){
    state[who]={
      lastID:0,
      nomore:true,
      data:[]
    }
  },
  setPagination(state,params){
    const res = params.res.data;
    const data = state[params.who];
    if(res.length<params.pageSize){
      data.nomore = true;
      data.lastID = 0;
    }else{
      data.nomore = false;
      data.lastID = res[res.length-1][params.label];
    }
    data.data = data.data.concat(res);
  },
  setSearchInGroupResault(state, res) {
    let l = state.search_in_group_result.length
    if(!!l){
      // 除颤
      state.search_in_group_result = state.search_in_group_result[l-1].create_date != res.data[res.data.length-1].create_date ? state.search_in_group_result.concat(res.data) : null;
    }else{
      state.search_in_group_result = res.data
    }
    
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}